import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import axios from "axios";
import AxiosPlugin from "@/api/axiosInit";
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss';
import { initGlobalState, registerMicroApps, start } from 'qiankun';
import { subAppsConfig } from '@/subAppConfig';
// import { cacheGet } from '@/utils/cacheRequest';
import { getUserInfo } from '@/api/user';
import fundebugLoad from '@/utils/fundebug';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(AxiosPlugin, axios);
fundebugLoad({
  vue: Vue
})
// 全局state
const initData = {
  downloadVisible: false, // 导出列表
};

const isPro = process.env.NODE_ENV === "production";

const setDataBeforeAppLoad = async () => {
  // 初始化
  window._userInfo_ = {};
  window._authCitys_ = [];
  window._functionAuthList_ = [];
  window._cityAuthList_ = [];
  window._areaAuthList_ = [];
  window._functionAuthGroupList_ = [];

  try {
    // db获取userInfo，如第一次获取，拉取一次，否则从db获取
    // 如果url包含unlogin，则不获取userInfo
    if (window.location.href.includes('cmtc_unlogin')) return;
    const res = await getUserInfo();
    if (+res.errno === 0) {
      const data = res.data;
      store.dispatch('user/changeUserInfo', data);
      window._userInfo_ = data;
      window._authCitys_ = data.cities || [];
      window._functionAuthList_ = data.functionAuthList || [];
      window._cityAuthList_ = data.cityAuthList || [];
      window._areaAuthList_ = data.areaAuthList || [];
      window._functionAuthGroupList_ = data.functionAuthGroupList || [];

      // 获取权限数据后加载menu, 防止获取不到window._functionAuthList_ 
      const menusMudle = await import('./menu');
      const menus = menusMudle.menus;
      store.dispatch('user/changeMenuData', menus);
    }
  } catch (error) {
    console.log('api error', error);
  }
}

const { onGlobalStateChange, setGlobalState } = initGlobalState(initData);
// 全局使用setGlobalState、_onGlobalStateChange_
window._setGlobalState_ = setGlobalState;
window._onGlobalStateChange_ = onGlobalStateChange;

/*
 *Step1 初始化主应用
 */
const maimApp = new Vue({
  router,
  store,
  render: (h) => h(App, {
    props: {
      onGlobalStateChange,
      setGlobalState,
    }
  }),
}).$mount("#layout-app");



/*
 *Step2 注册子应用
 */
registerMicroApps(subAppsConfig, {
  beforeLoad: [app => setDataBeforeAppLoad(app.name)],
  afterMount: [
    () => {
      // dev注册子应用保证vue子应用的devtools可用
      if (window.__QIANKUN_SUB_APP_VM__ && !isPro) {
        maimApp.$children.push(...window.__QIANKUN_SUB_APP_VM__);
      }
    }
  ],
});

/**
 * Step3 设置默认进入的子应用
 */
const entry = process.env.VUE_APP_ENTER;
const anyAppMounted = subAppsConfig.some(({activeRule}) => {
  if(typeof activeRule === 'string') {
    return window.location.pathname.match(new RegExp(activeRule));
  } else if(Array.isArray(activeRule)) {
    return activeRule.some(rule => window.location.pathname.startsWith(rule));
  }
});
// const isRedirectPath = window.location.pathname === "/ams/";
if (!anyAppMounted) {
  window.history.pushState(
    null,
    null,
    `${window.location.origin}${entry}#/`
  );
}

/**
 * Step4 启动应用
 */
start();